<template>
  <div class="launchpack-order">
    <div class="box" v-if="!isLaunchpack">
      <admin-box-item title="내 서비스 관리비">
        <div>
          <div>
            <div>사용 가능 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
          <div>
            <div>차감 예정 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
          <div>
            <div>월 이용 관리비</div>
            <div>{{ fee_info }}</div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="관리비 사용 내역"
      ref="admin_filter"
    ></admin-filter>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan">{{ props.item.created_time }}</td>
      <td slot="service_name" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan">{{ props.item.order.inquiry.service_name }}</td>
      <td slot="order_name" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan">{{ props.item.order.inquiry.title }}</td>
      <td slot="id" slot-scope="props" style="text-decoration: underline" class="unselect"
          @click="routerPush(getPath(`launchpack/management_fee_subtract/detail?id=${props.item.id}`))">{{ props.item.id }}
      </td>
      <td slot="item_name" slot-scope="props">{{ props.item.item_name }}</td>
      <td slot="price" slot-scope="props">{{ props.item.price }}</td>
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>
    </order-table>

  </div>
</template>
<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: "ManagementFee",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
      if(!this.isLaunchpack) {
        this.getMyFeeInfo();
      }
    },
    data() {
      return {
        fee_info: undefined
      }
    },
    watch: {
      tableItems(n) {
        this.tableItems.forEach(item=> {
          item.rowspan = 0;
        })
        for(let i=0; i<this.tableItems.length; i++) {
          this.tableItems[i].rowspan = 1;
          let j = 0;
          for(j=i+1; j<this.tableItems.length; j++) {
            // 주문 번호가 같을 경우
            if(this.tableItems[i].order.id === this.tableItems[j].order.id) {
              this.tableItems[i].rowspan += 1;
            }
            // 주문 번호가 다를 경우
            else {
              break;
            }
          }
          i = j-1;
        }
      }
    },
    methods: {
      init() {
        this.initializing('launchpack_orderproduct', 'launchpack/orderproduct');
      },
      getDataFromServer() {
        this.getData();
      },
      getMyFeeInfo() {
        this.$axios.get('admin/launchpack/my/management_fee/info').then(res=>{
          this.fee_info = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .launchpack-order td
    border 1px solid #dbdbdb
</style>
